import { lazyWithRetry } from "utils/lazy-with-retry";
import { FEATURE_FLAGS } from "config/feature-flags";
import Home from "components/home";

const ROUTE_TYPES = {
  PUBLIC: "public",
  PROTECTED: "protected",
  AUTH: "auth",
};

// Component imports with layouts grouping
const routes = {
  blankLayout: [
    {
      path: "*",
      element: lazyWithRetry(() => import("components/not-found")),
      isProtected: false,
      title: "Page Not Found - Kalyanawaran",
      screen: "Not Found",
    },
    {
      path: "/404",
      element: lazyWithRetry(() => import("components/not-found")),
      isProtected: false,
      title: "Page Not Found - Kalyanawaran",
      screen: "Not Found",
    },
  ],
  defaultLayout: [
    {
      // Eagerly imported so the LCP banner img renders without waiting for a lazy chunk
      path: "/",
      element: Home,
      isProtected: false,
      title: "Kalyanawaran - Matrimonial Service",
      screen: "Home",
    },
    {
      path: "/register",
      element: lazyWithRetry(() => import("components/register")),
      isProtected: false,
      title: "Register - Kalyanawaran",
      screen: "Register",
    },
    {
      path: "/login",
      element: lazyWithRetry(() => import("components/login")),
      isProtected: false,
      title: "Login - Kalyanawaran",
      screen: "Login",
    },
    {
      path: "/profileedit",
      element: lazyWithRetry(() => import("view/profile/edit")),
      isProtected: true,
      title: "Edit Profile - Kalyanawaran",
      screen: "Profile Edit",
    },
    {
      path: "/forgetpassword",
      element: lazyWithRetry(() => import("components/forget-password")),
      isProtected: false,
      title: "Forgot Password - Kalyanawaran",
      screen: "Forgot Password",
    },
    {
      path: "/search-profiles",
      element: lazyWithRetry(() => import("view/search-profile")),
      isProtected: true,
      title: "Search Profiles - Kalyanawaran",
      screen: "Search Profiles",
    },
    {
      path: "/members/:id",
      element: lazyWithRetry(() => import("view/members/members-pages")),
      isProtected: true,
      title: "Member Profile - Kalyanawaran",
      screen: "Member Profile",
    },
    {
      path: "/terms",
      element: lazyWithRetry(() => import("components/terms")),
      isProtected: false,
      title: "Terms & Conditions - Kalyanawaran",
      screen: "Terms",
    },
    {
      path: "/privacy-policy",
      element: lazyWithRetry(() => import("components/privacy-policy")),
      isProtected: false,
      title: "Privacy Policy - Kalyanawaran",
      screen: "Privacy Policy",
    },
    {
      path: "/cookie-policy",
      element: lazyWithRetry(() => import("components/cookie-policy")),
      isProtected: false,
      title: "Cookie Policy - Kalyanawaran",
      screen: "Cookie Policy",
    },
    ...(FEATURE_FLAGS.ENABLE_PREFERENCE
      ? [
          {
            path: "/preference",
            element: lazyWithRetry(
              () => import("view/preference/preference-pages")
            ),
            isProtected: true,
            title: "Preferences - Kalyanawaran",
            screen: "Preferences",
          },
        ]
      : []),
    {
      path: "/resetPassword/:token",
      element: lazyWithRetry(() => import("components/reset-password")),
      isProtected: false,
      title: "Reset Password - Kalyanawaran",
      screen: "Reset Password",
    },
    {
      path: "/emailVerification/:token",
      element: lazyWithRetry(() => import("components/email-verify")),
      isProtected: true,
      title: "Email Verification - Kalyanawaran",
      screen: "Email Verification",
    },
    {
      path: "/contact-us",
      element: lazyWithRetry(() => import("view/contact-us/contact-us")),
      isProtected: false,
      title: "Contact Us - Kalyanawaran",
      screen: "Contact Us",
    },
    {
      path: "/about-us",
      element: lazyWithRetry(() => import("view/about-us")),
      isProtected: false,
      title: "About Us - Kalyanawaran",
      screen: "About Us",
    },
    {
      path: "/nakshatra-rashi-list",
      element: lazyWithRetry(() => import("view/nakshatra-rashi-list")),
      isProtected: false,
      title: "Nakshatra Rashi List - Kalyanawaran",
      screen: "Nakshatra Rashi List",
    },
    {
      path: "/quick-upload",
      element: lazyWithRetry(() => import("view/quick-upload")),
      isProtected: false,
      title: "Quick Upload - Kalyanawaran",
      screen: "Quick Upload",
    },
    {
      path: "/gotralu",
      element: lazyWithRetry(() => import("components/gotralu/gotralu")),
      isProtected: false,
      title: "Gotralu - Kalyanawaran",
      screen: "Gotralu",
    },
    // Commented routes for future implementation
    // { path: "/counter", element: lazyWithRetry(() => import("components/counter")), isProtected: false, title: "Counter - Kalyanawaran", screen: "Counter" },
    // { path: "/verify", element: lazyWithRetry(() => import("components/verification/verification")), isProtected: false, title: "Verification - Kalyanawaran", screen: "Verification" },
    // { path: "/settings", element: lazyWithRetry(() => import("components/settings")), isProtected: false, title: "Settings - Kalyanawaran", screen: "Settings" },
    {
      path: "/account",
      element: lazyWithRetry(() => import("view/account/information")),
      isProtected: true,
      title: "Account Information - Kalyanawaran",
      screen: "Account Settings",
    },
    // { path: "/change-password", element: lazyWithRetry(() => import("view/account/change-password")), isProtected: false, title: "Change Password - Kalyanawaran", screen: "Change Password" },
  ],
};

export { ROUTE_TYPES };
export default routes;
